<!-- Start: Rejwan: 19-05-2025 Ess Approval Work -->
<template>
    <div>
        <b-modal size="lg" id="bv-modal-process-settlement" dialog-class="w-1200 title-alignment" hide-footer
            :title="'Settlement for ' + employee_name" title-class="w-800">
            <!-- {{ onAmountChange }} -->
            <b-overlay :show="showoverlaymodal" class='showoverlay_settle' rounded="sm">
                <!-- <div class="d-flex"> -->
                <div class="row">
                    <div class="col-md-8">
                        <b-form class="settlement-form">
                            <div class="clearfix">
                                <div class="row clearfix">
                                    <div class="col-md-12 float-left">

                                        <div class="d-flex" style="font-size: 13px;">
                                            <div class='text-left mb-4 col-md-6'>
                                                <span><span style="color: #004242; font-weight: 500;">Settlement ID:
                                                    </span> {{ settlement_fdata.settlement_company_code }}</span>
                                            </div>

                                            <div class='text-right mb-4 col-md-6'>
                                                <span class="px-3 py-1 rounded ml-2"
                                                    v-if="settlement_fdata.application_status == 1"
                                                    style="background: #00c177; color: #ffffff;">
                                                    Approved
                                                </span>
                                                <span class="px-3 py-1 rounded ml-2"
                                                    v-if="settlement_fdata.application_status == 6"
                                                    style="background: #00c177; color: #ffffff;">
                                                    Approved
                                                </span>
                                                <span class="px-3 py-1 rounded ml-2"
                                                    v-if="settlement_fdata.application_status == 2"
                                                    style="background: #e8b80f; color: #ffffff;">
                                                    Deferred
                                                </span>
                                                <span class="px-3 py-1 rounded ml-2"
                                                    v-if="settlement_fdata.application_status == -1"
                                                    style="background: #e8b80f; color: #ffffff;">
                                                    Awaiting Consent
                                                </span>
                                                <span class="px-3 py-1 rounded ml-2"
                                                    v-if="settlement_fdata.application_status == 5"
                                                    style="background: #e8b80f; color: #ffffff;">
                                                    Applied: Level 2
                                                </span>
                                            </div>
                                        </div>

                                        <div class="col-md-4 float-left">
                                            <dl class="row clearfix py-2 no-border no-shadow">
                                                <dt class="col-md-12 pl-0 pr-0 custom-label">Settlement Application Date
                                                </dt>
                                                <b-form-input id="application_date" name="application_date"
                                                    v-model="fdata.application_date" disabled></b-form-input>
                                            </dl>

                                            <dl class="row clearfix no-border no-shadow">
                                                <dt class="col-md-12 pl-0 pr-0 custom-label">Type of Settlement</dt>
                                                <b-form-select id="settlement_type" name="settlement_type"
                                                    data-vv-as="Type" :state="validateState('settlement_type')"
                                                    v-model="settlement_fdata.settlement_type"
                                                    :options="settlementOptions" v-validate="{ required: true }"
                                                    :disabled="disable_amount">
                                                </b-form-select>

                                                <b-form-invalid-feedback id="settlement_type-feedback">{{
                                                    veeErrors.first('settlement_type') }}</b-form-invalid-feedback>

                                            </dl>

                                            <dl class="row clearfix py-2  no-border no-shadow">
                                                <dt class="col-md-12 pl-0 pr-0 custom-label">Reason for Separation</dt>
                                                <b-form-input id="reason_for_separation" name="reason_for_separation"
                                                    v-model="fdata.reason_for_separation" disabled></b-form-input>
                                            </dl>

                                            <!-- Sifat: 07-07-2025 Check GF Module -->
                                            <dl class="row clearfix no-border no-shadow">
                                                <dt class="col-md-12 pl-0 pr-0 custom-label">Settlement Amount</dt>
                                                <b-form-input id="settlement_amount" name="settlement_amount"
                                                    v-model="fdata.settlement_amount"
                                                    :disabled="disable_amount"></b-form-input>
                                            </dl>
                                            <dl class="row clearfix no-border no-shadow">
                                                <dt class="col-md-12 pl-0 pr-0 custom-label">Tax Deduction at Source
                                                </dt>
                                                <b-form-input id="tax_deduction_at_source"
                                                    name="tax_deduction_at_source" v-model="fdata.tds_amount"
                                                    :disabled="disable_amount"></b-form-input>
                                            </dl>
                                            <dl class="row clearfix no-border no-shadow">
                                                <dt class="col-md-12 pl-0 pr-0 custom-label">Net Payable</dt>
                                                <b-form-input id="net_payable " name="net_payable"
                                                    v-model="fdata.net_payable"
                                                    :disabled="disable_amount"></b-form-input>
                                            </dl>
                                            <!-- Sifat: 07-07-2025 Check GF Module -->

                                        </div>

                                        <div class="col-md-8 float-right">
                                            <!-- <div class="d-flex">
                                                <div class="col-md-6 pl-0" style="color: #004242; font-weight: 500;">
                                                    <div class="py-2">Employee Code</div>
                                                    <div class="py-2">Employee Name</div>
                                                    <div class="py-2">Joining Date</div>
                                                    <div class="py-2">Leaving Date</div>
                                                    <div class="py-2">Confirmation Date</div>
                                                    <div class="py-2">Service Period</div>
                                                    <div class="py-2">Eligible Service Period</div>
                                                    <div class="py-2">GF Balance Payable</div>
                                                    <div class="py-2">GF Paid</div>
                                                </div>
                                                <div class="col-md-6 pl-0 pr-0">
                                                    <div class="py-2">{{ fdata.employee_code ? fdata.employese_code : ' ' }}</div>
                                                    <div class="py-2">{{ fdata.employee_name }}</div>
                                                    <div class="py-2">{{ fdata.joining_date }}</div>
                                                    <div class="py-2">{{ fdata.leaving_date }}</div>
                                                    <div class="py-2">{{ fdata.gf_confirmation_date }}</div>
                                                    <div class="py-2">{{ fdata.service_period }}</div>
                                                    <div class="py-2">{{ fdata.service_period }}</div>
                                                    <div class="py-2">{{ fdata.payable_amount }}</div>
                                                    <div class="py-2">{{ fdata.paid_amount }}</div>
                                                </div>
                                            </div> -->

                                            <div>
                                                <div class="d-flex py-2">
                                                    <div class="col-md-6 pl-0" style="color: #004242; font-weight: 500;">Employee Code</div>
                                                    <div class="col-md-6 pl-0 pr-0">{{ fdata.employee_code }}</div>
                                                </div>
                                                <div class="d-flex py-2">
                                                    <div class="col-md-6 pl-0" style="color: #004242; font-weight: 500;">Employee Name</div>
                                                    <div class="col-md-6 pl-0 pr-0">{{ fdata.employee_name }}</div>
                                                </div>
                                                <div class="d-flex py-2">
                                                    <div class="col-md-6 pl-0" style="color: #004242; font-weight: 500;">Joining Date</div>
                                                    <div class="col-md-6 pl-0 pr-0">{{ fdata.joining_date }}</div>
                                                </div>
                                                <div class="d-flex py-2">
                                                    <div class="col-md-6 pl-0" style="color: #004242; font-weight: 500;">Leaving Date</div>
                                                    <div class="col-md-6 pl-0 pr-0">{{ fdata.leaving_date }}</div>
                                                </div>
                                                <div class="d-flex py-2">
                                                    <div class="col-md-6 pl-0" style="color: #004242; font-weight: 500;">Service Period</div>
                                                    <div class="col-md-6 pl-0 pr-0">{{ fdata.service_period }}</div>
                                                </div>
                                                <div class="d-flex py-2">
                                                    <div class="col-md-6 pl-0" style="color: #004242; font-weight: 500;">GF Balance Payable</div>
                                                    <div class="col-md-6 pl-0 pr-0">{{ fdata.payable_amount }}</div>
                                                </div>
                                                <div class="d-flex py-2">
                                                    <div class="col-md-6 pl-0" style="color: #004242; font-weight: 500;">GF Paid</div>
                                                    <div class="col-md-6 pl-0 pr-0">{{ fdata.paid_amount }}</div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>



                                    <div class="card-body">
                                        <div class="employee-table-wrapper">

                                            <table class="employee-list-table dataTable table-overflow table-sticky">
                                                <tbody>
                                                    <b-form-group id="settlement_details-group" label="Remarks"
                                                        class="required-field" label-for="settlement_details">
                                                        <b-form-textarea id="settlement_details"
                                                            :disabled="disable_amount" name="settlement_details"
                                                            v-model="fdata.details"></b-form-textarea>
                                                        <b-form-invalid-feedback id="settlement_details-feedback">{{
                                                            veeErrors.first('settlement_details')
                                                        }}</b-form-invalid-feedback>
                                                    </b-form-group>
                                                    <!-- <a v-if="fdata.id > 0" href="javascript:void(0);" class="btn mb-2 btn-primary d-inline-block px-4"  @click="showAttachments()" >View Attachments</a> -->
                                                    <a v-if="settlement_fdata.id > 0" href="javascript:void(0);"
                                                        class="btn mb-2 btn-primary d-inline-block px-4"
                                                        @click="showAttachments()">View Attachments</a>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>


                                </div>
                            </div>

                            <template v-if="action_type == 'resubmit'">
                                <b-overlay :show="showoverlayapproval" class='showoverlay_settle' rounded="sm">
                                    <div class="ibox">
                                        <div class="ibox-content p-3">
                                            <div class="py-3" style="font-size: 13px;">
                                                <div class="text-center modal-title">
                                                    <h5 class="modal-title">Approval</h5>
                                                </div>
                                                <div class="d-flex py-3">
                                                    <div class="col-md-6 pl-0">Current approval Level: {{
                                                        settlement_fdata.application_status_label }}</div>
                                                    <div class="col-md-6 text-right pr-0">
                                                        <b-button class="employee-filter-btn  custom-primary-btn"
                                                            @click="showApprovalHistoryNew()"> Approval
                                                            History</b-button>
                                                    </div>
                                                </div>
                                                <div class="d-flex">
                                                    <div class="col-md-4 mt-3 pl-0">
                                                        <b-form-group id="settlement_date-group"
                                                            label="Deferred On [YYYY-MM-DD]" label-for="settlement_date"
                                                            v-if="settlement_fdata.last_approval_details">
                                                            <b-input-group class="mb-3">
                                                                <b-form-input id="settlement_date"
                                                                    :disabled="auto_filled"
                                                                    :state="validateState('settlement_date')"
                                                                    name="settlement_date"
                                                                    v-model="settlement_fdata.last_approval_details.date"
                                                                    type="text" placeholder="YYYY-MM-DD"
                                                                    autocomplete="off"
                                                                    v-validate="{ required: true, date_format: 'yyyy-MM-dd' }"
                                                                    aria-describedby="settlement_date-feedback"
                                                                    data-vv-as="Date"></b-form-input>
                                                                <template>
                                                                    <b-form-datepicker id="settlement_date" button-only
                                                                        right locale="en-US"
                                                                        v-model="settlement_fdata.last_approval_details.date"></b-form-datepicker>
                                                                </template>
                                                                <b-form-invalid-feedback
                                                                    id="settlement_date-feedback">{{
                                                                        veeErrors.first('settlement_date')
                                                                    }}</b-form-invalid-feedback>
                                                            </b-input-group>
                                                        </b-form-group>

                                                    </div>
                                                    <div class="col-md-2 mt-3 pl-0"></div>
                                                    <div class="col-md-6 mt-3 pr-0">
                                                        <b-form-group id="last_approval_details-group"
                                                            label="Deferment Remarks" label-for="last_approval_details"
                                                            v-if="settlement_fdata.last_approval_details">
                                                            <b-form-textarea id="last_approval_details"
                                                                :disabled="auto_filled"
                                                                :state="validateState('last_approval_details')"
                                                                name="last_approval_details"
                                                                v-model="settlement_fdata.last_approval_details.comment"
                                                                v-validate="{ required: true }" rows="3" max-rows="6"
                                                                no-resize
                                                                aria-describedby="last_approval_details-feedback"
                                                                data-vv-as="Details"></b-form-textarea>
                                                            <b-form-invalid-feedback
                                                                id="last_approval_details-feedback">{{
                                                                    veeErrors.first('last_approval_details')
                                                                }}</b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </div>


                                                </div>
                                                <div class="col-md-12 mt-3 pr-0">
                                                    <b-form-group id="approver_remarks-group" label="Remarks"
                                                        label-for="approver_remarks" class="required-field">
                                                        <b-form-textarea id="approver_remarks"
                                                            :state="validateState('approver_remarks')"
                                                            name="approver_remarks" v-model="approver_remarks"
                                                            v-validate="{ required: true }" rows="3" max-rows="6"
                                                            no-resize aria-describedby="approver_remarks-feedback"
                                                            data-vv-as="Remarks"></b-form-textarea>
                                                        <b-form-invalid-feedback id="approver_remarks-feedback">{{
                                                            veeErrors.first('approver_remarks')
                                                        }}</b-form-invalid-feedback>
                                                    </b-form-group>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <template>
                                        <div class="mt-1 ml-4 mb-4 pb-3 clearfix text-center"
                                            style="margin-right: 18px;">
                                            <b-button class="border rounded bg-light py-1 px-5 mt-4 ml-2"
                                                variant="primary" :disabled="pf_from_disable"
                                                @click="reSubmit">Re-Submit</b-button>
                                        </div>

                                    </template>
                                </b-overlay>
                            </template>


                            <template v-else>
                                <template v-if="settlement_fdata.application_id > 0">
                                    <gf-settlement-approval-section :pageurl="$api_url" :quick_view="quick_view"
                                        :action_type="action_type" :settlement_fdata="settlement_fdata"
                                        is_valid="is_valid"
                                        v-on:childToParent="approvalReturn"></gf-settlement-approval-section>
                                </template>
                            </template>

                            <template v-if="action_type == 'revert'">
                                <b-overlay :show="showoverlayapproval" class='showoverlay_settle' rounded="sm">
                                    <div class="ibox">
                                        <div class="ibox-content p-3">
                                            <div class="py-3" style="font-size: 13px;">
                                                <div class="text-center modal-title">
                                                    <h5 class="modal-title">Revertal</h5>
                                                </div>
                                                <div class="col-md-12 mt-3 pr-0">
                                                    <b-form-group id="approver_remarks-group"
                                                        label="Reason for Reversal " label-for="approver_remarks"
                                                        class="required-field">
                                                        <b-form-textarea id="approver_remarks"
                                                            :state="validateState('approver_remarks')"
                                                            name="approver_remarks" v-model="approver_remarks"
                                                            v-validate="{ required: true }" rows="3" max-rows="6"
                                                            no-resize aria-describedby="approver_remarks-feedback"
                                                            data-vv-as="Remarks"></b-form-textarea>
                                                        <b-form-invalid-feedback id="approver_remarks-feedback">{{
                                                            veeErrors.first('approver_remarks')
                                                        }}</b-form-invalid-feedback>
                                                    </b-form-group>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mt-1 ml-4 mb-4 pb-3 clearfix text-center"
                                            style="margin-right: 18px;">
                                            <b-button class="border rounded bg-light py-1 px-5 mt-4 ml-2"
                                                variant="primary" :disabled="pf_from_disable"
                                                @click="revert">Revert</b-button>
                                        </div>
                                    </div>

                                    <template>


                                    </template>
                                </b-overlay>
                            </template>
                        </b-form>
                    </div>
                    <div class="col-md-4 loan-comments border-left">
                        <h5 class="modal-title text-center">Recent Comments</h5>
                        <advance-settlement-discuss-discussion-thread :pageurl="$api_url" :ref_id="settlement_fdata.id" module="10"
                            :company_id='settlement_fdata.company_id' :key="thread_key"></advance-settlement-discuss-discussion-thread>
                    </div>
                </div>


            </b-overlay>
        </b-modal>

        <b-modal id="bv-modal-approval-history-new" size="lg" hide-footer title="Approval History test">
            <div class="col-sm-12 mt-1 mb-1">
                <advance-settlement-approver-approval-history :pageurl="$api_url" :application_id="this.settlement_fdata.application_id" module="10" :company_id='this.settlement_fdata.company_id' :key="thread_key"></advance-settlement-approver-approval-history>
            </div>
        </b-modal>
        <b-modal id="show_attachments" size="lg" hide-footer title="Application Files" scrollable>
            <gf-settlement-documents :pageurl="this.$api_url" flg="1" :key="flg_key"
                :settlement_id="settlement_fdata.id"></gf-settlement-documents>
        </b-modal>

    </div>
</template>
<script>

export default {

    mounted() {

    },
    props: ['flg', 'pageurl', 'settlement_id', 'employee_id', 'employee_name', 'quick_view', 'action_type'],
    components: {

    },

    data() {


        return {
            // Start: Rejwan
            settlementOptions: [{ text: 'Select Settlement Type', value: null }, { text: 'Final Settlement', value: 0 }, { text: 'Partial Settlement', value: 1 }],
            auto_filled: true,
            fdata: {
                employee_id: 0,
                settlement_type: null,
                application_date: null,
                reason_for_separation: null,
                employee_code: null,
                employee_name: null,
                joining_date: null,
                leaving_date: null,
                gf_confirmation_date: null,
                service_period: null,
                eligible_service_period: null,
                payable_amount: null,
                settlement_amount: null,
                remarks: null,
                bank_id: 0,
                tds_amount: 0, // Sifat: 07-07-2025 Check GF Module
                net_payable: 0 // Sifat: 07-07-2025 Check GF Module
            },

            settlement_fdata: {
                employee_id: 0,
                //   id: 0,
                id: this.settlement_id,
                settlement_amount: 0,
                settlement_date: null,
                settlement_details: '',
                settlement_status: null,
                settlement_type: null,
                reason: null,
            },

            flg_key: 0,

            accept: ".jpg, .png, .gif, .pdf , .doc , .docx",
            attachment: 'Attachments',
            multiple: true,
            attachment: 'Upload File',
            document: null,
            bdata: null,
            disable_amount: true,
            thread_key: 0,

            // End: Rejwan

            showoverlaymodal: false,
            disabled: true,
            approver_remarks: '',
            approver_decision: null,
            decision_option: [{ text: 'Approve', value: 1 }, { text: 'Defer', value: 2 }, { text: 'Reject', value: 3 }],
            pf_from_disable: false,
            showoverlayapproval: false,
        }
    },
    methods: {
        // Start: Rejwan:
        listReturnAttachment: function (data) {
            // Start: Rejwan: 30-04-2025 File Upload
            this.document = data;
            // End: Rejwan: 30-04-2025 File Upload
        },
        showApprovalHistoryNew() {
            // return; // prevent further execution until timeout
            // this.fdata.net_settlement_payable = this.calCulateNetSettlementPayable(amount, tds);
            // console.log(this.fdata.net_settlement_payable, amount, tds);
            this.thread_key += 1;
            this.$bvModal.show('bv-modal-approval-history-new');
        },
        approvalReturn: function () {
            this.$bvModal.hide('bv-modal-process-settlement');
            this.$emit('childToParent');
        },
        showAttachments() {
            this.$bvModal.show('show_attachments');
            this.flg_key += 1;
        },

        showBankInfo: function () {
            this.$bvModal.show('bv-modal-bank');
        },
        getBankInfo: function (employee_id) {
            let currentObj = this;
            axios.get(this.$api_url + '/gf/employee/bank-info', {
                params: {
                    employee_id: employee_id
                }
            }).then(function (response) {
                this.bdata = response.data;
            }.bind(this)).catch(function (error) {
                currentObj.showoverlay = false;
            });
        },

        resetForm() {
            this.fdata = {
                // return; // prevent further execution until timeout
                // this.fdata.net_settlement_payable = this.calCulateNetSettlementPayable(amount, tds);
                // console.log(this.fdata.net_settlement_payable, amount, tds);
                employee_id: 0,
                id: 0,
                settlement_type: null,
                application_date: null,
                reason_for_separation: null,
                employee_code: null,
                employee_name: null,
                joining_date: null,
                leaving_date: null,
                gf_confirmation_date: null,
                service_period: null,
                eligible_service_period: null,
                payable_amount: null,
                settlement_amount: null,
                remarks: null,
                settlement_status: null,
                bank_id: 0,
            },
                this.document = null;

        },

        reSubmit() {
            let settle_data = this.settlement_fdata;
            if (!this.checkNet()) return false;
            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }

                let currentObj = this;
                currentObj.showoverlayapproval = true;
                let formData = new FormData();
                formData.append('settlement_id', settle_data.id);
                formData.append('employee_id', settle_data.employee_id);
                formData.append('company_id', settle_data.company_id);
                formData.append('approval_application_id', settle_data.application_id);
                formData.append('approval_user_type', 0);
                formData.append('approval_approver_id', 0);
                formData.append('approval_comment', this.approver_remarks);
                formData.append('approval_module', 10);
                formData.append('settlement_type', this.settlement_fdata.settlement_type);
                formData.append('settlement_amount', this.fdata.settlement_amount);
                formData.append('details', this.fdata.details);

                axios.post(this.$api_url + '/approver/re-submit', formData)
                    .then(function (response) {
                        currentObj.$bvToast.toast('Success', {
                            title: `Success`,
                            variant: 'success',
                            solid: true
                        });
                        currentObj.showoverlayapproval = false;

                        currentObj.$bvModal.hide('bv-modal-process-settlement');
                        currentObj.$emit('childToParent');
                    });
            });

        },
        // Start: Rejwan
        processSettlement: function (employee_id, settlement_id) {
            let currentObj = this;

            axios.get(this.$api_url + '/gf/employee/settlement-data', {
                params: {
                    employee_id: employee_id,
                    settlement_id: settlement_id,
                }

            }).then(function (response) {

                this.fdata = response.data;
                this.getSettlementApplicationData(this.settlement_id);

                //this.settlement_fdata.loan = this.curr_emp_loan_total;

            }.bind(this)).catch(function (error) {

                console.log(error)
            });


        },

        getSettlementApplicationData: function (settlement_id) {
            let currentObj = this;

            let formData = new FormData();
            formData.append('id', settlement_id);
            axios.post(this.$api_url + '/gf/settlement/details', formData)
                .then(function (response) {
                    currentObj.settlement_fdata = response.data;
                    currentObj.thread_key += 1;
                    currentObj.showoverlaymodal = false;
                });
        },

        // processGfSettlement: function(employee_id, settlement_id)
        // {
        //     let currentObj = this;
        //     currentObj.showoverlay = true;
        //     console.log('settlement_id');
        //     console.log(settlement_id);
        //     axios.get(this.$api_url+'/gf/employee/settlement-data' , {
        //         params: {
        //             employee_id: employee_id,
        //             settlement_id: settlement_id,
        // 		}
        //     }).then(function(response){
        //         this.fdata = response.data;
        //         // this.fdata.settlement_type = this.settlement_data.settlement_type;
        //         this.$bvModal.show('bv-modal-process-settlement');
        //         currentObj.showoverlay = false;

        //         }.bind(this)).catch(function (error){
        //         currentObj.showoverlay = false;
        //     });
        // },
        // End: Rejwan
        // Start:
        revert() {
            this.$validator.validate().then(valid => {
                if (!valid) return;

                this.showoverlayapproval = true;
                this.pf_from_disable = true;
                let settle_data = this.settlement_fdata;
                let formData = new FormData();
                formData.append('settlement_id', this.settlement_id);
                formData.append('remarks', this.approver_remarks);
                formData.append('approval_application_id', settle_data.application_id);
                formData.append('employee_id', this.employee_id);
                formData.append('approval_module', 10);

                axios.post(this.$api_url + '/gf/revert-settlement', formData)
                    .then(response => {
                        if (response.data.success) {
                            this.$bvToast.toast('Settlement reverted successfully!', {
                                title: 'Success',
                                variant: 'success',
                                solid: true
                            });

                            this.closeModal();  // Hide modal
                            this.$emit('childToParent'); // Refresh parent
                        } else {
                            this.$bvToast.toast('Failed to revert settlement.', {
                                title: 'Error',
                                variant: 'danger',
                                solid: true
                            });
                        }
                    })
                    .catch(() => {
                        this.$bvToast.toast('Something went wrong.', {
                            title: 'Error',
                            variant: 'danger',
                            solid: true
                        });
                    })
                    .finally(() => {
                        this.showoverlayapproval = false;
                        this.pf_from_disable = false;
                    });
            });
        },

        closeModal() {
            this.quick_view = 0;  // Hide modal
        }
        // End:


    },
    created: function () {
        // Start: Rejwan
        this.getBankInfo(this.employee_id);
        if (this.settlement_id > 0 && this.employee_id > 0) {
            if (this.action_type == 'resubmit') {
                this.disable_amount = false;
            }

            setTimeout(() => {
                this.$bvModal.show('bv-modal-process-settlement');
                this.processSettlement(this.employee_id, this.settlement_id);
            }, 1000);

        }
        // if(this.settlement_id == 0 && this.employee_id > 0) {
        //     this.processGfSettlement(this.employee_id, this.settlement_id);
        // }
        //  else if(this.settlement_id > 0 && this.employee_id > 0)
        // {
        //     setTimeout(() => {

        //         this.fdata = this.settlement_data;
        //         this.processGfSettlement(this.employee_id);

        //     }, 1000);

        // }
        //   End: Rejwan
    },
}
</script>
<style scoped>
#bv-modal-process-settlement .form-control.is-valid {
    padding-right: .75rem !important;
    z-index: 1;
}

/* Start: Rejwan: 16-02-2025 */
.error-message {
    white-space: normal;
}

/* End: Rejwan: 16-02-2025 */

.custom-label {
    color: rgb(0, 66, 66);
    font-weight: 500;
}
</style>
<!-- End: Rejwan: 19-05-2025 Ess Approval Work -->
